import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block overflow-hidden rounded-xl bg-background-50"
      data-product-shop="comic"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden rounded-xl">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title}漫画在线看`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-background-50/90 px-2 py-0.5 text-[11px] font-medium text-primary-600">
          {comic.status}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-primary-500/90 px-2 py-0.5 text-[11px] font-medium text-background-50">
          <i className="ri-star-fill text-[10px]" />
          {comic.rating}
        </span>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent px-3 pb-2 pt-8 text-background-50">
          <p className="text-xs font-medium">第{comic.chapters}话 · {comic.views}</p>
        </div>
      </div>
      <div className="px-1 pt-3">
        <h3 className="truncate text-sm font-bold text-foreground-800 group-hover:text-primary-600">
          {comic.title}
        </h3>
        <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">{comic.genre}</span>
          <span className="truncate">{comic.author}</span>
        </div>
      </div>
    </Link>
  );
}